<template>
    <card-seplag :titulo="'Vínculos'" class="" cor="#00acc1" > 
        <div class="p-col-12 avisos">
            <p>Siga os Passos a Seguir: </p>
            <ol>
                <li class="passosSeguir">
                    Atualize as informações dos seus vínculos.
                </li>
                <li class="passosSeguir">
                    Informe a matrícula do chefe imediato que validará seu vínculo.
                </li>
                <li class="passosSeguir">
                    Aguarde a validação da chefia imediata.
                </li>
                <li class="passosSeguir">
                    Após todos os vínculos forem validados será possível consultar e emitir os protocolos de conclusão do recadastramento.
                </li>
            </ol>
            <p><strong>Obs.: Caso tenha dúvidas sobre a matrícula da sua chefia imediata, entre em contato com a Gestão de Pessoas do seu órgão de lotação.</strong></p>
        </div>
        <card-seplag :titulo="'Vínculos do poder executivo estadual'" cor="#00acc1" >   
            <div class="p-col-12 ajusteSecao">
        <div  v-if="vinculosPEE && vinculosPEE.length>0" class="p-col-12 ajustePanel">
          <button v-for="(item, index ) in vinculosPEE" :key="item.idenVinculoCiclo"  type="button" @click="funcaoAccord(index)" class="p-col-12 ajustePanel">
            <Panel :toggleable="true" :collapsed="controlePanel[index]" class="p-col-12 ajustePanel">          
                <template slot="header">
                <span class="acordion">{{colapseTeste}}</span>
                <span> 
                    {{index + 1 +" - "+item.vinculo.orgao.siglOrgao}}
                    {{item.vinculo.cargo? ' - '+item.vinculo.cargo.descSeap : ""}}
                  <!--   <i v-if="item.situacaoFuncional == 'IRREGULAR'" class="dotIrregular pi pi-times-circle"></i> -->                     
                        <span v-if="item.situacaoFuncional == 'IRREGULAR'" class="statusVinculoIrregular alinhamentoNome">IRREGULAR</span>
                        <span v-if="item.statVinculoCiclo=='REJEITADO'" class="statusVinculoIrregular alinhamentoNome">Rejeitado</span>
                        <span v-if="item.statVinculoCiclo=='PENDENTE' && item.situacaoFuncional != 'IRREGULAR'" class="statusVinculoPendente alinhamentoNome">Pendente</span>
                        <span v-if="item.statVinculoCiclo=='PENDENTE_VALIDACAO'" class="statusVinculoPendente alinhamentoNome">AGUARDANDO VALIDAÇÃO</span>
                        <span v-if="item.statVinculoCiclo=='CONCLUIDO'" class="statusVinculoPendente alinhamentoNome">Concluido</span>
                        <span v-if="item.statVinculoCiclo=='VALIDADO'" class="statusVinculoPendente alinhamentoNome">Validado</span> 
                       
                </span>
                <span class="acordion">{{ isCollapsed }}</span>
              </template>
              <div class="p-grid p-fluid">
                <div class="p-col-12 " >
                    <!-- {{item.statVinculoCiclo}} -->
                            <!-- <Message v-if="item.situacaoFuncional == 'REGULAR'" severity="success" :closable="false">{{item.situacaoFuncionalCompleta}}</Message>   -->
                            <Message v-if="item.situacaoFuncional == 'IRREGULAR'" severity="error" :closable="false">{{item.situacaoFuncionalCompleta}}</Message>   
                            <Message v-if="item.statVinculoCiclo=='REJEITADO'" severity="error" :closable="false">{{item.statusVinculoCompleto}}</Message> 
                            <Message v-if="item.statVinculoCiclo=='PENDENTE'" severity="warn" :closable="false">{{item.statusVinculoCompleto}}</Message>     
                            <Message v-if="item.statVinculoCiclo=='PENDENTE_VALIDACAO'" severity="warn" :closable="false">{{item.statusVinculoCompleto}}</Message>                           
                            <Message v-if="item.statVinculoCiclo=='CONCLUIDO'" severity="success" :closable="false">{{item.statusVinculoCompleto}}</Message>                         
                        </div>                            
                        <div class="p-col-12 ajusteContent" v-if="item.vinculo && item.vinculo.descCategoria">
                            <label><strong>Categoria: </strong>{{item.vinculo.descCategoria}}</label>                            
                        </div>                    
                        <div class="p-col-12 ajusteContent" v-if="item.vinculo && item.vinculo.orgao && item.vinculo.orgao.descOrgao">
                            <label><strong>Órgão: </strong>{{item.vinculo.orgao.descOrgao}}</label>                            
                        </div>                 
                        <div class="p-col-12 ajusteContent" v-if="item.vinculo && item.vinculo.unidade && item.vinculo.unidade.descUnidade">
                            <label><strong>Setor: </strong>{{item.vinculo.unidade.descUnidade}}</label>                            
                        </div>                          
                        <div class="p-col-12 p-md-6 ajusteContent">
                            <label><strong>Perfil de ingresso: </strong>{{item.perfilIngresso? item.perfilIngresso.descPerfilIngresso: "Não Informado"}}</label>                            
                        </div>                    
                        <div class="p-col-12 p-md-6 ajusteContent" >
                            <label><strong>Chefia indicada: </strong>{{item.numrMatriculaChefia? item.numrMatriculaChefia : "Não Informado"}}{{item.nomeChefe? " - " + item.nomeChefe : ""}}</label>                            
                        </div>                  
                        <div class="p-col-12 p-md-6 ajusteContent" v-if="item.vinculo && item.vinculo.dataExercicio">
                            <label><strong>Data de exercício: </strong>{{item.vinculo.dataExercicio}}</label>                            
                        </div>                   
                        <div class="p-col-12  p-md-6 ajusteContent" v-if="item.vinculo && item.vinculo.statVinculo">
                            <label><strong>Situação funcional: </strong>{{item.situacaoFuncional}}</label>                            
                        </div>
                        <div class="p-col-12 ajusteContent" v-if="item.vinculo">
                            <label><strong>Validado: </strong>{{item.flagValidado=='S'? "Sim": "Não"}}</label>                            
                        </div>   
    
                        <div class="p-col-12 p-md-4 ajusteContent" v-if="item.situacaoFuncional != 'IRREGULAR'">
                            <Button label="Editar" @click="editarVinculo(item)" icon="pi pi-pencil" class="p-button-success"/>
                        </div>
              </div>
            </Panel>
          </button>
        </div>

        <span v-else><i>Nenhum registro encontrado</i></span>
      </div>
            <div class="p-col-12 p-md-5">
                <label class="label-pergunta" >Possui outro vínculo externo ao Poder Executivo Estadual de MT?</label>
                <SelectButton v-model="outroVinculomodal.flagPossuiOutroVinculo" :options="simNao" optionLabel="name" :disabled="outroVinculomodal.flagOutroVinculoSalvo" />
           </div>
           <card-seplag :titulo="'Outro vínculo'" cor="#00acc1" v-if="outroVinculomodal.flagPossuiOutroVinculo && outroVinculomodal.flagPossuiOutroVinculo.code=='S'" :legendaObrigatorio="true" >           
               <Rotulo nome="Poder:" cols='12 6'>
                    <Dropdown v-model="outroVinculomodal.poderGoverno" :options="poderes" optionLabel="descEsferaGoverno"  placeholder="Selecione..." :filter="true"  v-required />
                </Rotulo>
               <Rotulo nome="Esfera:" cols='12 6'>
                    <Dropdown v-model="outroVinculomodal.esferaGoverno" :options="esferas" optionLabel="descEsferaGoverno"  placeholder="Selecione..." :filter="true"  v-required/>
                </Rotulo>
                <Rotulo nome="Órgão:" cols='12'>
                    <InputText type="text" v-model="outroVinculomodal.nomeOrgao"  v-required />
                </Rotulo>
                <Rotulo nome="Cargo:" cols='12'>
                    <InputText type="text" v-model="outroVinculomodal.nomeCargo"  v-required />
                </Rotulo>
                <Rotulo nome="Remuneração bruta:" cols='12'>
                    <money v-model="outroVinculomodal.valrRemuneracaoBruta" v-bind="money" class="p-inputtext p-component p-filled" v-required></money> 
                </Rotulo>     
                <div class="p-col-12">   
                    <div class="p-grid">
                        <div class="p-col-12 p-md-3 p-md-offset-6">
                            <Button label="Deletar" @click="abrirDialogoDeletar()" icon="pi pi-trash" class="p-button-danger" v-if="outroVinculomodal.flagOutroVinculoSalvo"/>
                        </div>

                        <div class="p-col-12 p-md-3 ">
                            <Button label="Salvar" @click="salvarOutroVinculo()" icon="pi pi-check" class="p-button-success" />
                        </div>
                    </div>   
                </div> 
           </card-seplag>  
        </card-seplag >       
        <div class="p-col-12">   
            <div class="p-grid">
                <div class="p-col-12 p-md-3 p-md-offset-6">
                    <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />        
                </div>
                <div class="p-col-12 p-md-3">
                    <Button label="Salvar e Fechar" icon="pi pi-times" @click="abrirDialogoFecharRecad()" class="p-button-success" v-tooltip.top="'O seu recadastramento será finalizado após a validação da sua chefia imediata.'"/>               
                </div>
            </div>   
        </div>               
        <!-- MODAL VINCULO -->
        <Dialog :header="tituloModalVinculo" :visible.sync="exibirModalVinculo" :style="{width: '60vw'}" :modal="true" v-if="vinculoSelecionado">         
            <TabView class="p-col-12" :activeIndex.sync="tabActive">
                <TabPanel >
                    <template #header>
                        <i class="pi pi-id-card" style="font-size: 2em;"></i>
                        <span>Dados vínculo</span>
                    </template>
                    <br>
                    <Rotulo nome="Categoria:" cols='12' v-if="vinculoSelecionado.vinculo && vinculoSelecionado.vinculo.descCategoria">
                        <span>{{vinculoSelecionado.vinculo.descCategoria}}</span>
                    </Rotulo>
                    <Rotulo nome="Cargo:" cols='12' v-if="vinculoSelecionado.vinculo && vinculoSelecionado.vinculo.cargo">
                        <span>{{vinculoSelecionado.vinculo.cargo.descSeap}}</span>
                    </Rotulo>
                    <Rotulo nome="Perfil de ingresso:" cols='12'>
                        <Dropdown v-model="vinculoSelecionado.perfilIngresso" :options="perfisIngresso" optionLabel="descPerfilIngresso" placeholder="Selecione..."  :filter="true"  />
                    </Rotulo>
                    <Rotulo nome="Cota de deficiente no ingresso:" cols='12'>
                        <SelectButton v-model="vinculoSelecionado.flagCotaDeficiente" :options="simNao" optionLabel="name" />
                    </Rotulo>
                    <Rotulo nome="Órgão:" cols='12' v-if="vinculoSelecionado.vinculo && vinculoSelecionado.vinculo.orgao">
                        <span>{{vinculoSelecionado.vinculo.orgao.descOrgao}}</span>
                    </Rotulo>
                    <Rotulo nome="Setor:" cols='12' v-if="vinculoSelecionado.vinculo && vinculoSelecionado.vinculo.unidade">
                        <span>{{vinculoSelecionado.vinculo.unidade.descUnidade}}</span>
                    </Rotulo>
                    <Rotulo nome="Confirma lotação:" cols='12'>
                        <SelectButton v-model="vinculoSelecionado.flagLotacaoCorreta" :options="simNao" optionLabel="name" @input="alteraConfirmacaoLotacao()" />
                    </Rotulo>
                    <br>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-12 p-md-4  p-md-offset-4">
                                <Button label="Cancelar" icon="pi pi-ban" @click="fecharModalVinculo()" class="p-button-danger" /> 
                            </div>
                            <div class="p-col-12 p-md-4">
                                <Button :label="'Salvar Edição'" icon="pi pi-check" @click="salvarVinculo()" class="p-button-success" v-if="vinculoSelecionado.flagChefiaRh=='S'" :disabled="desabilitaFinalizarEdicao"  />
                                <Button :label="'Próximo'" icon="pi pi-angle-right" @click="alteraAbaModalVinculo()" class="p-button-primary" iconPos="right" v-else :disabled="desabilitaFinalizarEdicao"  />
                            </div>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel v-if="vinculoSelecionado.flagChefiaRh=='N'" >
                    <template #header>
                        <i class="pi pi-users" style="font-size: 2em;"></i>
                        <span>Chefia imediata</span>
                    </template>
                    <br>                    
                    <Rotulo nome="Informe a matrícula do seu chefe imediato:" cols='12'>
                        <br>
                        <div class="p-grid">    
                            <div class="p-col-12 p-md-4">
                                <InputText type="number" v-model="matriculaChefia" placeholder="Matrícula" />
                            </div>
                            <div class="p-col-12 p-md-6">
                                <InputText type="text" v-model="chefiaNome" placeholder="Nome Encontrado" disabled />
                            </div>
                            <div class="p-col-12 p-md-2">
                                <Button label="Buscar" icon="pi pi-search" @click="buscarChefia()" class="p-button-info" />
                            </div>
                        </div>
                    </Rotulo>
                    <Rotulo nome="Hierarquia:" cols='12'>
                        <DataTable :value="arvoreHierarquica" class="p-datatable-striped">
                            <Column field="setor" header="Código do Setor" style="w" :headerStyle="'width: 10vw'" :bodyStyle="'text-align:center'"></Column>
                            <Column field="nomeSetor" header="Setor" :bodyStyle="'text-align:center'"></Column>
                        </DataTable>
                    </Rotulo>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-12 p-md-4  p-md-offset-4">
                                <Button label="Cancelar" icon="pi pi-ban" @click="fecharModalVinculo()" class="p-button-danger" /> 
                            </div>
                            <div class="p-col-12 p-md-4">
                                <Button :label="'Salvar Edição'" icon="pi pi-check" @click="salvarVinculo()" :disabled="desabilitaFinalizarEdicao" class="p-button-success" />
                            </div>
                        </div>
                    </div> 
                </TabPanel>
            </TabView>                           
        </Dialog> 

        <Dialog header="Confirmação" :visible.sync="exibirDialogoDeletar" :style="{width: '33vw'}" :modal="true" v-if="exibirDialogoDeletar">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: red;" />
                <span>Você tem certeza que deseja <strong>EXCLUIR</strong> o vínculo ?</span>
            </div>
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="fecharDialogoDeletar" class="p-button-text"/>
                <Button label="Sim" icon="pi pi-trash" @click="excluirVinculo()" class="p-button-text p-button-danger" autofocus />
            </template>
        </Dialog> 

        <Dialog header="Confirmação" :visible.sync="exibirDialogoFecharRecad" :style="{width: '33vw'}" :modal="true" v-if="exibirDialogoFecharRecad">
            <div class="confirmation-content center">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: green; " />
                <br>
                <span> Você receberá um e-mail de validação da sua chefia imediata, e, assim, seu recadastramento será finalizado, gerando o protocolo.</span>
            </div>
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" @click="fecharDialogoFecharRecad" class="p-button-text" />
                <Button label="Sim" icon="pi pi-check" @click="logout()" class="p-button-text p-button-success" autofocus />
            </template>
        </Dialog> 

    </card-seplag>  
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { Money } from 'v-money'
import { baseApiUrl } from '@/config/global'
import { simNao,money } from '@/config/global'

const getDadosVinculo = () => {
    return {
        flagPossuiOutroVinculo: {name: 'Não', code: "N"},        
        flagOutroVinculoSalvo: false,
        esferaGoverno: null,
        poderGoverno: null,
        nomeOrgao: null,
        nomeCargo: null,
        valrRemuneracaoBruta: 0
    }
}

export default {
    name: "vinculos",
    components: {CardSeplag,Rotulo,Money},
    data: function(){        
        return {
            faseAtual: 'VINCULOS',
            outroVinculomodal: getDadosVinculo(),
            vinculosPEE: [],
            controleAccord: [],
            perfisIngresso: [],
            escolaridades: [],
            exibirModal: false,
            tituloModalVinculo: "VINCULO",
            exibirModalVinculo: false,
            exibirModalOutroVinculo: false,
            simNao: simNao,
            money: money,
            vinculoSelecionado: null,
            matriculaChefia: null,
            chefiaNome: null,
            arvoreHierarquica: [],
            tabActive: 0,
            desabilitaFinalizarEdicao: false,
            esferas:[],
            poderes: [],
            exibirDialogoDeletar: false,
            exibirDialogoFecharRecad: false,
            isCollapsed: false,
            controlePanel: [],
            colapseTeste:[],
            documentoPendente: false

        }
    },
    methods:{
        async carregarDados(){          
            if(this.$store.getters.getDadosPessoa){ 
                 this.$http.get(`${baseApiUrl}/vinculos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res =>{
                    this.vinculosPEE = res.data
                    for(let i=0;i<this.vinculosPEE.length;i++){
                        this.controlePanel[i] = true
                        this.colapseTeste[i] = false
                    }
                })
                // Listar Escolaridades
                // await  this.$http.get(`${baseApiUrl}/escolaridades/recadastramento/all`).then(res3 =>{
                //     this.escolaridades = res3.data
                // })

                // Listar Esferas
                  this.$http.get(`${baseApiUrl}/esferagovernos/all`).then(res4 =>{
                    this.esferas = res4.data
                })

                // Listar Poder
                  this.$http.get(`${baseApiUrl}/podergovernos/all`).then(res5 =>{
                    this.poderes = res5.data
                })

                // Outro Vínculo
                  this.$http.get(`${baseApiUrl}/outrovinculociclos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res6 =>{
                    if(res6.data){
                        this.outroVinculomodal = Object.assign( { flagOutroVinculoSalvo: true, flagPossuiOutroVinculo: {name: 'Sim', code: "S"} },res6.data )
                    }
                })

            }else{
                this.$router.push({name:"recadastramento"})
            }
        },
        editarVinculo(vinculo){                
            this.$http.get(`${baseApiUrl}/vinculos/${vinculo.idenVinculoCiclo}`).then(res =>{
                this.vinculoSelecionado = res.data                
                this.vinculoSelecionado.pathAplicacao =  window.location.origin+"/recadastramento"
                
                if(this.vinculoSelecionado.vinculo && this.vinculoSelecionado.vinculo.orgao && this.vinculoSelecionado.vinculo.cargo){
                    this.tituloModalVinculo = this.vinculoSelecionado.vinculo.orgao.siglOrgao+' - '+this.vinculoSelecionado.vinculo.cargo.descSeap
                }else{
                    if(this.vinculoSelecionado.vinculo){
                        this.tituloModalVinculo = "Vínculo "+this.vinculoSelecionado.vinculo.numrVinculo 
                    }else{
                        this.tituloModalVinculo = "Vínculo"
                    }
                }
                this.tabActive=0;
                this.exibirModalVinculo = true     

                if(this.vinculoSelecionado.flagCotaDeficiente=='S'){
                    this.vinculoSelecionado.flagCotaDeficiente = {name: 'Sim', code: "S"}
                }else{
                    this.vinculoSelecionado.flagCotaDeficiente = {name: 'Não', code: "N"}
                }

                if(this.vinculoSelecionado.flagLotacaoCorreta=='S'){
                    this.vinculoSelecionado.flagLotacaoCorreta = {name: 'Sim', code: "S"}
                }else{
                    this.vinculoSelecionado.flagLotacaoCorreta = {name: 'Não', code: "N"}
                }

                if(this.vinculoSelecionado.vinculo.unidade == null || this.vinculoSelecionado.vinculo.unidade.codgSeap == null){
                    this.$toast.add({severity:'error', summary: 'Edição de Vínculo', detail:'Unidade não cadastrada! ', life: 10000});  
                    this.exibirModalVinculo = false     
                }else{
                    this.$http.get(`${baseApiUrl}/setores/${this.vinculoSelecionado.vinculo.unidade.codgSeap}`).then(res2 =>{
                    this.arvoreHierarquica = res2.data
                    })
                }
                
                if(this.vinculoSelecionado.vinculo.cargo == null){
                    this.$toast.add({severity:'error', summary: 'Edição de Vínculo', detail:'Cargo não cadastrado! ', life: 10000});  
                    this.exibirModalVinculo = false                     
                }else{

                    this.$http.get(`${baseApiUrl}/cargoperfis/cargo/${this.vinculoSelecionado.vinculo.cargo.idenCargo}`).then(res3 =>{
                    this.perfisIngresso = res3.data
                    })
                    this.matriculaChefia = this.vinculoSelecionado.numrMatriculaChefia
                    this.chefiaNome = this.vinculoSelecionado.nomeChefe  
                }          
            })
        },
        finalizarRecadastramento(){
            if(this.outroVinculomodal.flagPossuiOutroVinculo && this.outroVinculomodal.flagPossuiOutroVinculo.code=='S'){
                if(this.outroVinculomodal.flagOutroVinculoSalvo){                    
                    this.$http.put(`${baseApiUrl}/vinculos/concluir/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res =>{
                        this.$toast.add({severity:'success', summary: res.data , life: 10000})
                        this.$router.push({name:"recadastramento"})
                    })
                }else{
                    this.$toast.add({severity:'error', summary: 'Erro ao finalizar etapa', detail:'Por favor salve as informações do outro vínculo fora do poder executivo estadual ', life: 10000});
                }
            }else{                    
                this.$http.put(`${baseApiUrl}/vinculos/concluir/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res =>{
                    this.$toast.add({severity:'success', summary: res.data , life: 10000})
                    this.$router.push({name:"recadastramento"})
                })
            }
        },
        buscarChefia(){ 
            let bodyRequisicao = {
                "matServidor" : this.vinculoSelecionado.vinculo.numrMatricula,
                "vincServidor": this.vinculoSelecionado.vinculo.numrVinculo,
                "matChefe": this.matriculaChefia,
                "setor": this.vinculoSelecionado.vinculo.unidade.codgSeap,
                "orgao": this.vinculoSelecionado.vinculo.orgao.codSeap
            }       
            this.$http.put(`${baseApiUrl}/vinculos/chefia`,JSON.stringify(bodyRequisicao)).then(res =>{
                this.chefiaNome = res.data.nome
                this.vinculoSelecionado.numrMatriculaChefia = res.data.numrMatricula
            })
        },        
        salvarOutroVinculo(){
            this.$http.post(`${baseApiUrl}/outrovinculociclos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`,JSON.stringify(this.outroVinculomodal)).then(res =>{
                this.$toast.add({severity:'success', summary: res.data , life: 6000})
                this.outroVinculomodal.flagOutroVinculoSalvo = true
            })
        },
        alteraConfirmacaoLotacao(){
            if(this.vinculoSelecionado && this.vinculoSelecionado.flagLotacaoCorreta && this.vinculoSelecionado.flagLotacaoCorreta.code=='N'){
                this.$toast.add({severity:'error', summary: 'Lotação incorreta: procure a sua gestão de pessoas em posse dos seus documentos pessoais para a correção', life: 10000})
                this.desabilitaFinalizarEdicao = true
            }else if(this.vinculoSelecionado && !this.vinculoSelecionado.flagLotacaoCorreta){
                this.$toast.add({severity:'error', summary: 'Lotação incorreta: Selecione uma opção', life: 10000})
                this.desabilitaFinalizarEdicao = true
            }else{
                this.desabilitaFinalizarEdicao = false
            }
        },
        abrirModalOutroVinculo(){
            this.outroVinculomodal = getDadosVinculo()
            this.exibirModalOutroVinculo = true
        },
        fecharModalVinculo(){
            this.vinculoSelecionado = null
            this.tituloModalVinculo = "MODAL VINCULO"
            this.exibirModalVinculo = false    
        },
        fecharModalOutroVinculo(){
            this.outroVinculomodal = getDadosVinculo()
            this.exibirModalOutroVinculo = false
        },
        alteraAbaModalVinculo(){
            this.tabActive=1;
        },
        salvarVinculo(){
            if(this.vinculoSelecionado.flagCotaDeficiente && this.vinculoSelecionado.flagCotaDeficiente.code=='S'){
                this.vinculoSelecionado.flagCotaDeficiente = "S"
            }else{
                this.vinculoSelecionado.flagCotaDeficiente = "N"
            }

            if(this.vinculoSelecionado.flagLotacaoCorreta && this.vinculoSelecionado.flagLotacaoCorreta.code =='S'){
                this.vinculoSelecionado.flagLotacaoCorreta = "S"
            }else{
                this.vinculoSelecionado.flagLotacaoCorreta = "N"
            }

            this.$http.put(`${baseApiUrl}/vinculos/recad/${this.vinculoSelecionado.idenVinculoCiclo}`,JSON.stringify(this.vinculoSelecionado)).then(res =>{
                this.$http.get(`${baseApiUrl}/vinculos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res2 =>{
                    this.vinculosPEE = res2.data
                    this.controleAccord = []
                    for(let i=0;i<this.vinculosPEE.length;i++){
                        this.controlePanel[i] = true
                        this.colapseTeste[i] = false
                    }
                    this.fecharModalVinculo()
                    this.$toast.add({severity:'success', summary: res.data, life: 10000})
                })
            })
        },
        prevPage(){
            if(this.$store.getters.getDadosPessoa && this.$store.getters.getCicloPessoa.length > 0 ){
                let fases  = this.$store.getters.getEtapasCiclo.filter(element =>{
                    return element.fase.statFase=='ATIVO'
                })
                if(fases.length>0){
                    let faseAnterior = ''
                    for(let i=0; i<fases.length;i++){
                        if(fases[i].fase.descFase == this.faseAtual){
                            break;
                        }else{
                            faseAnterior = fases[i].fase.descFase;
                        }
                    }
                    let nomeRota = ''
                    if(faseAnterior=='DADOS_PESSOAIS'){
                    nomeRota = 'RECAD_DADOS_PESSOAIS_VIEW'
                    }else if(faseAnterior=='DOCUMENTO'){
                        nomeRota = 'RECAD_DOCUMENTOS_PESSOAIS_VIEW'
                    }else if(faseAnterior=='ENDERECO'){
                        nomeRota = 'RECAD_ENDERECO_VIEW'
                    }else if(faseAnterior=='FORMACAO_ACADEMICA'){
                        nomeRota = 'RECAD_FORMACAO_ACADEMICA_VIEW'
                    }else if(faseAnterior=='CAPACITACAO'){
                        nomeRota = 'RECAD_CAPACITACAO_VIEW'
                    }else if(faseAnterior=='EXPERIENCIA_PROFISSIONAL'){
                        nomeRota = 'RECAD_EXPERIENCIA_PROFISSIONAL_VIEW'
                    }else if(faseAnterior=='DEPENDENTES'){
                        nomeRota = 'RECAD_DEPENDENTES_VIEW'
                    }else if(faseAnterior=='QUESTIONARIO'){
                        nomeRota = 'RECAD_QUESTIONARIO_VIEW'
                    }else if(faseAnterior=='VINCULOS'){
                        nomeRota = 'RECAD_VINCULOS_VIEW'
                    }
                    this.$router.push({name:nomeRota})
                }
            }else{
                this.$router.push({name:"recadastramento"})
            }
        }, 
        logout(){
                if(process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS!='false'){  
					this.$recaptchaInstance.showBadge()
				}
				this.$store.dispatch('logoutUsuario')
				if(this.$route.name!='recadastramento'){
					this.$router.push({name:'recadastramento'})
				}
		},
        abrirDialogoDeletar(){
            this.exibirDialogoDeletar = true
        },
        fecharDialogoDeletar(){
            this.exibirDialogoDeletar = false
        },
        abrirDialogoFecharRecad(){
            // this.$http.get(`${baseApiUrl}/relatorios/enviar_resumo_recad/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`)
            this.exibirDialogoFecharRecad = true
        },
        fecharDialogoFecharRecad(){
            this.exibirDialogoFecharRecad = false
        },
        excluirVinculo(){
            this.$http.delete(`${baseApiUrl}/outrovinculociclos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(() =>{
                this.exibirDialogoDeletar = false
                this.$toast.add({severity:'success', summary: "Viculo excluído com sucesso", detail:'' , life: 6000})
                this.outroVinculomodal = getDadosVinculo()
                 
            })
        },
        funcaoAccord(index) {
            this.controlePanel[index] = this.isCollapsed
            this.isCollapsed = !this.isCollapsed 
            this.controlePanel[index] =  this.colapseTeste[index] 
            this.colapseTeste[index] = !this.colapseTeste[index]
    },
        verificaDocumentosPendentes() {
          return this.$http.get(`${baseApiUrl}/documentos/ciclo-pessoas/verifica-documento-pendente/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res => {
            let condicao = res.data
            if (condicao) {
              this.$toast.add({ severity: 'error', summary: 'Você possui documentos pendentes na etapada 2.', life: 5000 })
              this.documentoPendente = true
            }
          })
        }
    },
    mounted(){        
        this.carregarDados()
    }
    
}
</script>
<style>
.divcontainerButton{
    margin-top: 1rem;
    width: 100%;
}
.divButton{
    width: 10% !important;
}
.statusVinculoPendente{
    color: #f2bf27;
    margin-right: 3px;
}
.statusVinculoIrregular{
    color: #f27777;
    margin-right: 3px;
}
.statusVinculoConcluido{
    color: #43a047;
    margin-right: 3px;
}
.avisos{
    background-color:rgb(231 232 125 / 84%); /* Red */
    color: #000000;
    border-radius: 12px;
}
.passosSeguir{
    list-style-type: decimal-leading-zero;
    margin-left: 3vw;
}
.dotPendente2 {
    width:  2vw;
    color: #f2bf27;
    display: inline-block;
    font-size: 2vw !important;
}
.dotConcluido {
    width:  2vw;
    color: #43a047;
    display: inline-block;
    font-size: 2vw !important;
}
.dotIrregular {
    width:  2vw;
    color: #f27777;
    display: inline-block;
    font-size: 2vw !important;
}
.label-pergunta {
    font-weight: 600;
    color: rgb(110, 106, 106);
    padding-bottom: 8px;
}
.ajusteSecao {
  margin-top: 20px;
}

.ajustaBotao {
  /* justify-items: ; */
  justify-content: space-between;
  margin-top: 20px;
}

.ajustePanel {
  margin-top: -15px;
}
.ajusteContent{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start !important;
    justify-items: flex-start;
    margin-right: 1500px;
}

.acordion {
  display: none;
}

.center{
    text-align: center;    
}

@media screen and (max-width: 40em) {   
    .passosSeguir{
        margin-left: 9vw;
        text-align: justify;
    } 
}
</style>